import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowUp,
} from "react-icons/md";
import BetSlipContext from "../../context/BetSlipContext";
import { isEmpty, lowerCase, startCase } from "lodash";
import VelkieLayout from "./VelkieLayout";
import GameMenu from "./GameMenu";
import { usePolling } from "../../component/usePolling";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import NoEvent from "./NoEvent";
import BeforeLoader from "./BeforeLoader";
import ListingSportComp from "./ListingSportComp";
import DropdownMenu from "./DropdownMenu";
import ListingSports from "./ListingSports";
import SearchWrapper from "./SearchWrapper";
const Index = () => {
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const setSportsTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSportsTab;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });

  const tab = useContextSelector(AuthContext, (ctx) => {
    return ctx.tab;
  });
  const setParlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlay;
  });

  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const setTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setTab;
  });

  const navigate = useNavigate();
  const [setting, setSetting] = useState(false);
  const [data, setData] = useState([]);
  const [dataComp, setDataComp] = useState([]);
  const [multiOddsPremium, setMultiOddsPremium] = useState([]);
  const [newResult, setNewResult] = useState([]);
  const [selectedOption, setSelectedOption] = useState("by Competition"); // default selected
  const [eventIdPremium, setEventIdPremium] = useState([]);
  const [allOdds, setAllOdds] = useState([]);
  const [isOpen, setIsOpen] = useState(false); // dropdown open/close
  const [count, setCount] = useState({
    cricketInplayCount: 0,
    soccerInplayCount: 0,
    tennisInplayCount: 0,
  });
  const [notification, setNotification] = useState(false);
  const [search, setSearch] = useState(false);
  const [list, setList] = useState([]);
  const [activeFav, setActiveFav] = useState([]);
  const [loader, setLoader] = useState(false);
  const isFirstRun = useRef(true);
  const stableTab = useMemo(() => tab, [tab]);
  const isSportTab = useMemo(() => sportTab, [sportTab]);
  const [showScore, setShowScore] = useState([]);
  const [showAll, setShowAll] = useState({
    cricket: false,
    soccer: false,
    tennis: false,
  });
  const [activeKeysAll, setActiveKeysAll] = useState({
    cricket: [],
    tennis: [],
    soccer: [],
  });
  const handleScore = (e) => {
    if (showScore.includes(e)) {
      setShowScore((prev) => {
        return prev?.filter((res) => {
          return res != e;
        });
      });
    } else {
      setShowScore([...showScore, e]);
    }
  };
  const filteredArray = (array) => {
    if (array?.length > 0) {
      let check = array?.filter((res) => {
        return res?.seriesName == "Others";
      });
      if (check?.length > 1) {
        let find = check?.find((res) => {
          return res?.seriesName == "Others";
        });
        return [
          ...array?.filter((res) => {
            return res?.seriesName !== "Others";
          }),
          {
            ...find,
            matchList: check
              ?.map((res) => {
                return res?.matchList;
              })
              .flat(),
          },
        ];
      } else {
        return array;
      }
    }
  };
  const handleActive = (key, id, check) => {
    if (isEmpty(id)) {
      if (check) {
        setActiveKeysAll((prev) => {
          return {
            ...prev,
            [key]: (isSportTab == "all" ? dataComp[key] : data)?.map((res) => {
              return res?.seriesId;
            }),
          };
        });
      } else {
        setActiveKeysAll((prev) => {
          return {
            ...prev,
            [key]: [],
          };
        });
      }
      setShowAll((prev) => {
        return {
          ...prev,
          [key]: check,
        };
      });
    } else {
      setActiveKeysAll((prev) => {
        return {
          ...prev,
          [key]: prev[key]?.includes(id)
            ? prev[key]?.filter((res) => {
                return res !== id;
              })
            : [...prev[key], id],
        };
      });
    }
  };
  const getData = async () => {
    setLoader(true);
    setAllOdds([]);
    setMultiOddsPremium([]);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: isSportTab,
      type: stableTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });

    if (data?.success) {
      let newResult = data?.results
        ?.map((res) => {
          return res?.matchList;
        })
        .flat();

      setActiveFav(
        newResult
          ?.filter((res) => {
            return res?.isFavourite;
          })
          ?.map((res) => {
            return res?.eventId;
          })
      );
      if (parlay) {
        setEventIdPremium(
          newResult?.map((res) => {
            return res?.eventId;
          })
        );
      } else {
        setNewResult(
          newResult?.filter((res) => {
            return res?.hasMatchOdds;
          })
        );
      }
      if (isSportTab == "all") {
        let obj = {
          cricket: filteredArray(
            data?.results?.filter((res) => {
              return res?.gameType == "cricket";
            })
          ),
          soccer: filteredArray(
            data?.results?.filter((res) => {
              return res?.gameType == "soccer";
            })
          ),
          tennis: filteredArray(
            data?.results?.filter((res) => {
              return res?.gameType == "tennis";
            })
          ),
        };
        setData({
          cricket:
            obj?.cricket
              ?.map((res) => {
                return res?.matchList;
              })
              .flat() || [],
          soccer:
            obj?.soccer
              ?.map((res) => {
                return res?.matchList;
              })
              .flat() || [],
          tennis:
            obj?.tennis
              ?.map((res) => {
                return res?.matchList;
              })
              .flat() || [],
        });
        setActiveKeysAll({
          cricket:
            obj?.cricket?.length > 0
              ? obj?.cricket
                  ?.filter((res) => {
                    return res?.hasMatchOddsInList;
                  })
                  ?.map((res) => {
                    return res?.seriesId;
                  })
              : [],
          soccer:
            obj?.soccer?.length > 0
              ? obj?.soccer
                  ?.filter((res) => {
                    return res?.hasMatchOddsInList;
                  })
                  ?.map((res) => {
                    return res?.seriesId;
                  })
              : [],
          tennis:
            obj?.tennis?.length > 0
              ? obj?.tennis
                  ?.filter((res) => {
                    return res?.hasMatchOddsInList;
                  })
                  ?.map((res) => {
                    return res?.seriesId;
                  })
              : [],
        });
        setDataComp({
          cricket:
            filteredArray(
              data?.results?.filter((res) => {
                return res?.gameType == "cricket";
              })
            ) || [],
          soccer:
            filteredArray(
              data?.results?.filter((res) => {
                return res?.gameType == "soccer";
              })
            ) || [],
          tennis:
            filteredArray(
              data?.results?.filter((res) => {
                return res?.gameType == "tennis";
              })
            ) || [],
        });
      } else {
        setData(
          filteredArray(data?.results)
            ?.map((res) => {
              return res?.matchList;
            })
            .flat()
        );
        setDataComp(filteredArray(data?.results));
        setActiveKeysAll({
          [isSportTab]:
            data?.results?.length > 0
              ? data?.results
                  ?.filter((res) => {
                    return res?.hasMatchOddsInList;
                  })
                  ?.map((res) => {
                    return res?.seriesId;
                  })
              : [],
        });
      }
    }
    setLoader(false);
  };

  const leagueData = async () => {
    const { status, data } = await apiGet(apiPath.seriesList, {
      gameType: isSportTab,
    });
    if (data?.success) {
      setList(data?.results);
    }
  };
  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.inPlayCountMobile,
      {
        type: stableTab,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results) {
          setCount(response_users.results);
        }
      }
    }
  };
  const getPremiumMulti = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getPremiumFancy +
        `?events=${[...new Set(id)]?.join(",")}&parly=true&multi=true`
    );
    if (status === 200) {
      if (response_users.success) {
        const socket_data = response_users?.results;
        setMultiOddsPremium(socket_data);
      }
    }
  };
  const getOdds = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds +
        `?marketId=${id
          ?.map((res) => {
            return res?.marketId;
          })
          ?.join(",")}&multi=true&eventIds=${id
          ?.map((res) => {
            return res?.eventId;
          })
          ?.join(",")}`
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users.results?.length > 0) {
          setAllOdds(response_users.results);
        }
      }
    }
  };
  const fetchOdds = useCallback(async () => {
    if (
      newResult?.length > 0 &&
      !parlay &&
      selectedOption == "by Competition" &&
      !search
    ) {
      await getOdds(newResult);
    }
  }, [parlay, newResult, selectedOption, search]);

  const fetchPremium = useCallback(async () => {
    if (
      eventIdPremium?.length > 0 &&
      !isEmpty(user) &&
      parlay &&
      selectedOption == "by Competition" &&
      !search
    ) {
      await getPremiumMulti(eventIdPremium);
    }
  }, [eventIdPremium, user, parlay, selectedOption, search]);

  usePolling(
    fetchOdds,
    5000,
    newResult?.length > 0 &&
      !parlay &&
      selectedOption == "by Competition" &&
      !search
  );
  usePolling(
    fetchPremium,
    10000,
    eventIdPremium?.length > 0 &&
      !isEmpty(user) &&
      parlay &&
      selectedOption == "by Competition" &&
      !search
  );

  useEffect(() => {
    getData();
    inPlayCount();
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }
    if (stableTab == "leagues") {
      leagueData();
    } else {
      if (isSportTab != "myfav") {
        getData();
        inPlayCount();
      }
    }
  }, [stableTab, isSportTab, parlay]);

  const addToFavioute = async (
    id,
    favoriteType,
    favoriteMarketId,
    eventType
  ) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
        `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${eventType}&market=Match Odds`
    );

    if (response_users?.success) {
      if (activeFav?.includes(id)) {
        setActiveFav((prev) => {
          return prev.filter((item) => {
            return item !== id;
          });
        });
      } else {
        setActiveFav((prev) => {
          return [...prev, id];
        });
      }
    }
  };

  return (
    <VelkieLayout visibilityType={true}>
      <GameMenu setSearch={setSearch} game={sportTab} setGame={setSportsTab} />
      <DropdownMenu
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        isSportTab={isSportTab}
        showAll={showAll}
        handleActive={handleActive}
      />
      {loader ? (
        <BeforeLoader />
      ) : true ? (
        <>
          {selectedOption == "by Time" ? (
            <div className="s-min-h-full-with-header s-pb-20px">
              {isSportTab == "all" ? (
                data?.cricket?.length +
                  data?.soccer?.length +
                  data?.tennis?.length >
                0 ? (
                  <>
                    {data?.cricket?.length > 0 && (
                      <ListingSports
                        heading={"Cricket"}
                        data={data?.cricket}
                        handleScore={handleScore}
                        showScore={showScore}
                        isSportTab={isSportTab}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}{" "}
                    {data?.soccer?.length > 0 && (
                      <ListingSports
                        heading={"Soccer"}
                        data={data?.soccer}
                        handleScore={handleScore}
                        showScore={showScore}
                        isSportTab={isSportTab}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}{" "}
                    {data?.tennis?.length > 0 && (
                      <ListingSports
                        heading={"Tennis"}
                        data={data?.tennis}
                        handleScore={handleScore}
                        showScore={showScore}
                        isSportTab={isSportTab}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}
                  </>
                ) : (
                  <NoEvent />
                )
              ) : data?.length > 0 ? (
                <ListingSports
                  heading={startCase(isSportTab)}
                  data={data}
                  handleScore={handleScore}
                  showScore={showScore}
                  isSportTab={isSportTab}
                  addToFavioute={addToFavioute}
                  activeFav={activeFav}
                />
              ) : (
                <NoEvent />
              )}
            </div>
          ) : (
            <div className="s-min-h-full-with-header s-pb-20px">
              {isSportTab == "all" ? (
                dataComp?.cricket?.length +
                  dataComp?.soccer?.length +
                  dataComp?.tennis?.length >
                0 ? (
                  <>
                    {dataComp?.cricket?.length > 0 && (
                      <ListingSportComp
                        heading={"Cricket"}
                        data={dataComp?.cricket}
                        odds={parlay ? multiOddsPremium : allOdds}
                        type={isSportTab}
                        handle={handleActive}
                        active={activeKeysAll?.cricket}
                        handleScore={handleScore}
                        showScore={showScore}
                        showAll={showAll?.cricket}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}{" "}
                    {dataComp?.soccer?.length > 0 && (
                      <ListingSportComp
                        heading={"Soccer"}
                        data={dataComp?.soccer}
                        odds={parlay ? multiOddsPremium : allOdds}
                        type={isSportTab}
                        handle={handleActive}
                        active={activeKeysAll?.soccer}
                        handleScore={handleScore}
                        showScore={showScore}
                        showAll={showAll?.soccer}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}{" "}
                    {dataComp?.tennis?.length > 0 && (
                      <ListingSportComp
                        heading={"Tennis"}
                        data={dataComp?.tennis}
                        odds={parlay ? multiOddsPremium : allOdds}
                        type={isSportTab}
                        handle={handleActive}
                        active={activeKeysAll?.tennis}
                        handleScore={handleScore}
                        showScore={showScore}
                        showAll={showAll?.tennis}
                        addToFavioute={addToFavioute}
                        activeFav={activeFav}
                      />
                    )}
                  </>
                ) : (
                  <NoEvent />
                )
              ) : dataComp?.length > 0 ? (
                <ListingSportComp
                  heading={startCase(isSportTab)}
                  data={dataComp}
                  odds={parlay ? multiOddsPremium : allOdds}
                  type={isSportTab}
                  handle={handleActive}
                  active={activeKeysAll[lowerCase(isSportTab)]}
                  showAll={showAll[lowerCase(isSportTab)]}
                  handleScore={handleScore}
                  showScore={showScore}
                  addToFavioute={addToFavioute}
                  activeFav={activeFav}
                />
              ) : (
                <NoEvent />
              )}
            </div>
          )}{" "}
        </>
      ) : (
        <NoEvent />
      )}
      {search && <SearchWrapper setSearch={setSearch} />}
    </VelkieLayout>
  );
};

export default Index;
